module.exports = __webpack_public_path__ + "img/icon-tag-hover.10d5ec3.svg";